import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"

import {panel_action_get_panel} from "../../../store/actions/panel";
import {Loading} from "carbon-components-react";

import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';


class Panel extends Component {

    async componentDidMount() {
        await this.props.fetchData(this.props.match.params.id);
        const {data} = this.props;
        await this.getQuickSightDashboardEmbedURL(data);
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            const id = nextProps.match.params.id
            await this.props.fetchData(id);
            const {data} = this.props;
            await this.getQuickSightDashboardEmbedURL(data);

        }
    }

    getQuickSightDashboardEmbedURL(url) {

        const options = {
            url: url,
            container: '#dashboardContainer',
            scrolling: "yes",
            height: "100%",
            width: "100%",
            footerPaddingEnabled: false,
        };
        QuickSightEmbedding.embedDashboard(options);
    }

    render() {
        const {isLoading} = this.props;
        // alert(this.props.match.params.id);
        if (!isLoading) {
            return (
                <Layout>
                    <div class="dashboardContainer" id="dashboardContainer"></div>
                </Layout>
            )
        } else {
            return (
                <Loading
                    description="Active loading indicator" withOverlay={true}
                />
            )
        }
    }
}

const mapStateToProps = ({panel}) => panel;

const mapDispatchToProps = dispatch => ({
    fetchData: (params) => dispatch(panel_action_get_panel(params)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Panel);
